import type { CitationType } from "./citation.utils"

import { Book, Calendar, FileText, Globe, Mail, MessageSquare } from "@/components/icons"
import { getM365Type } from "@/utils/citation-utils"

type CitationIconProps = {
  type: CitationType
  className?: string
  citation?: string
}

export function CitationIcon({ type, className = "size-3", citation }: CitationIconProps) {
  if (type === "web") {
    return <Globe className={className} />
  }

  if (type === "library") {
    return <Book className={className} />
  }

  if (type === "m365" && citation) {
    const m365Type = getM365Type(citation)
    switch (m365Type) {
      case "email":
        return <Mail className={className} />
      case "event":
        return <Calendar className={className} />
      case "teams":
        return <MessageSquare className={className} />
      case "file":
        return <FileText className={className} />
    }
  }

  return <FileText className={className} />
}
